import type { INotificationActionsChangeRequestProps } from '../../types';
import { AcceptRequestButton } from './AcceptRequestButton';

export function ChangeRequestAction({
	notification,
	applyChangeRequest,
	changeRequestApplied,
}: INotificationActionsChangeRequestProps) {
	if (!notification.request?.id) {
		return null;
	}

	const isApplied = notification.request?.applied || changeRequestApplied;

	return (
		<AcceptRequestButton
			applied={isApplied}
			onAccept={() => applyChangeRequest({ id: notification.request!.id })}
		/>
	);
}
